<template>
  <div class="form-group" :class="{'has-error': errors.has(inputId)}">
    <label :for="inputId" v-html="deleteTags(label)"></label>
    <label v-if="required" class="red"> *</label>
    <input
      :id="inputId"
      v-model="inputVal"
      :disabled="isEditable()"
      type="text"
      :name="inputId"
      class="form-control"
      autocomplete="off"
      v-validate="validations"
      :data-vv-as="'Email'"
      @input="validateEmail"
    >
    <small v-if="domains != '' " class="form-text">
      {{t('Valid email domains')}}: {{domains}}
    </small>
    <span class="md-error" v-if="required && errors.collect(inputId).length && inputVal=='' " >
      {{t('This field is required.')}}
    </span>
    <span class="md-error" v-else>
      {{ errors.first(inputId) }}
    </span>
    <span class="md-error" v-if="!validByDomains">
      <br>{{t('This email does not belong to the allowed domains')}}
    </span>
  </div>
</template>

<script>
import { Validator } from 'vee-validate';
export default {
  name: "checkout-form-input-email",
  props: ['value', 'label', 'required', 'inputValidations', 'uniqueId', 'domains', 'notEditable','level_access'],
  data() {
    return {
      inputVal: this.value,
      // Valor con el que cargó el campo; el bloqueo por notEditable se decide contra
      // este y no contra el valor vivo (si no, se deshabilita al primer carácter).
      initialValue: this.value,
      inputId: null,
      validByDomains:true
    };
  },
  inject: ['$validator'],
  computed: {
    _() {
      return _;
    },
    validations() {
      let validations = {};

      if (this.required) {
        validations.required = true;
      }

      if (this.inputValidations) {
        const dbValidations = JSON.parse(this.inputValidations);
        validations = Object.assign(validations, dbValidations);
      }

      validations.email = true;
      const propertyName = 'email_domain_' + this.uniqueId;
      validations[propertyName] = true; //dinamic validator

      return validations;
    }
  },
  watch: {
    value(val) {
      // Solo los cambios externos (carga o prefill) redefinen el valor inicial.
      if (val !== this.inputVal) {
        this.initialValue = val;
      }
      this.inputVal = val;
    },
    inputVal(val) {
      this.$emit('input', val);
    }
  },
  mounted() {
    var _this = this;
    Validator.extend('email_domain_' + this.uniqueId, {
      validate: value => {
        if (_this.domains && _this.domains.trim().length > 0) {
          const allowedDomains = _this.domains.split(',').map(domain => domain.trim());
          const emailDomain = _this.inputVal.split('@')[1];
          _this.validByDomains = allowedDomains.includes(emailDomain);
          return allowedDomains.includes(emailDomain);
        }
        _this.validByDomains = true;
        return true;
      },
      message: _this.t('This email does not belong to the allowed domains')
    });
  },
  created() {
    this.inputId = this.uniqueId || _.uniqueId();
  },
  methods: {
    deleteTags(label) {
      //let result = label.replace(/<[^>]*>?/gm, '');
      let result = label.replace(/\s*style=(["'])(.*?)\1/gmi, '')
      .replace(/<p[^>]*>/gmi, '');
      return result;
    },
    validateEmail() {
      this.inputVal = this.inputVal.replace(/\s+/g, ''); 
    },
    // OJO: devuelve si el campo está BLOQUEADO (se usa en :disabled), no lo contrario.
    isEditable() {
      return !!this.initialValue && this.notEditable == 1 && this.level_access !== 1;
    },
  }
};
</script>

<style scoped>
.red {
  color: #D95A4B !important;
}
</style>
